import React from "react";
import { useStyles } from "./style";
import Axios from "axios";
export default function NewsLetter() {
  const classes = useStyles();
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
    setError(false);
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      let body = {
        api_key: "pk_4bc3ef005d166379eca153d06ca519a338",
        profiles: [
          {
            email: email,
            property: "vgl newsletter",
          },
        ],
      };
      await Axios.post("http://localhost:3000/", body)
        .then((res) => {
          setError(false);
          setSuccess(true);
          setMessage("Check your email box!");
          setEmail("");
        })
        .catch((err) => {
          setError(true);
          setSuccess(false);
          setMessage("Something went wrong!");
        });
    } else {
      setError(true);
      setSuccess(false);
      setMessage("Email is required!");
    }
  };
  return (
    <div className={classes.vglNewsLetterForm}>
      <div>
        <form
          className={classes.vglSubscriptionForm}
          tabIndex={-1}
          noValidate
          onSubmit={handleSubmit}
        >
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <div>
              <p className={classes.vglFormHeading}>
                <strong>Newsletter</strong>
              </p>
            </div>
            <div style={{ padding: "10px 0px" }}>
              <p className={classes.vglFormHeading}>
                <span>Subscribe now to our newsletter</span>
              </p>
            </div>

            <input
              name="email"
              type="email"
              tabIndex={0}
              placeholder="Enter your email"
              aria-label="Enter your email"
              aria-invalid="false"
              valid={1}
              className={classes.vglFormInput}
              onChange={handleChange}
              required={true}
              value={email}
            />
            {error && (
              <p
                style={{
                  textAlign: "center",
                  color: "red",
                  marginTop: 5,
                  fontSize: 15,
                }}
              >
                {message}
              </p>
            )}
            {success && (
              <p
                style={{
                  textAlign: "center",
                  color: "green",
                  marginTop: -25,
                  marginTop: 5,
                  fontSize: 15,
                }}
              >
                {message}
              </p>
            )}

            <div style={{ padding: "10px 0px" }}>
              <p className={classes.vglFormHeading}>
                <span>
                  Subscribe now to our newsletter By signing up, you agree to
                  our Privacy Notice and European users agree to data transfer
                  policy.
                </span>
              </p>
            </div>
            <div>
              <button
                tabIndex={0}
                type="submit"
                className={classes.vglFormButtonSubmit}
              >
                Subscribe
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
